import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Link2, Copy } from "lucide-react";

const enc = encodeURIComponent;

const Section = ({ icon: Icon, title, desc, children, accent = "text-sky-300" }) => (
  <div className="rounded-3xl border border-white/10 bg-card/40 p-5 sm:p-6">
    <div className="mb-1 flex items-center gap-2">
      <Icon size={17} className={accent} />
      <h3 className="text-base font-semibold text-foreground">{title}</h3>
    </div>
    {desc && <p className="mb-4 text-sm text-muted-foreground">{desc}</p>}
    {children}
  </div>
);

export function UtmBuilderPanel() {
  const origin = typeof window !== "undefined" ? window.location.origin : "https://bougieducoeur.com";
  const [utmSource, setUtmSource] = useState("facebook");
  const [utmMedium, setUtmMedium] = useState("social");
  const [utmCampaign, setUtmCampaign] = useState("lancement");
  const utmLink = `${origin}/?utm_source=${enc(utmSource || "")}&utm_medium=${enc(utmMedium || "")}&utm_campaign=${enc(utmCampaign || "")}`;
  const copy = async (val, label = "Copié") => {
    try { await navigator.clipboard.writeText(val); toast.success(label); }
    catch { toast.error("Copie impossible"); }
  };
  return (
    <Section icon={Link2} title="Générateur de liens traçables (UTM)" desc="Créez un lien unique par canal pour savoir précisément d'où viennent vos visiteurs dans l'onglet Analyse.">
      <div className="grid gap-3 sm:grid-cols-3">
        <div><Label>Source</Label><Input value={utmSource} onChange={(e) => setUtmSource(e.target.value)} placeholder="facebook" data-testid="utm-source" /></div>
        <div><Label>Support</Label><Input value={utmMedium} onChange={(e) => setUtmMedium(e.target.value)} placeholder="social" data-testid="utm-medium" /></div>
        <div><Label>Campagne</Label><Input value={utmCampaign} onChange={(e) => setUtmCampaign(e.target.value)} placeholder="lancement" data-testid="utm-campaign" /></div>
      </div>
      <div className="mt-4 flex items-center gap-2 rounded-2xl border border-white/10 bg-black/20 p-3">
        <code className="min-w-0 flex-1 truncate text-xs text-sky-200" data-testid="utm-result">{utmLink}</code>
        <Button size="sm" variant="outline" className="shrink-0 rounded-full border-white/15" onClick={() => copy(utmLink, "Lien traçable copié")} data-testid="utm-copy"><Copy size={14} className="mr-1.5" /> Copier</Button>
      </div>
    </Section>
  );
}
